<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
          </div>
        </section>
      </b-card>

      <b-row>
        <b-col v-if="infoPanelOpen" lg="4">
          <b-card>
            <b-row>
              <b-col class="d-flex align-items-center">
                <b-avatar :src="suppliers.image"
                          size="25px"
                          v-if="suppliers.image">
                </b-avatar>
                <b-avatar v-else
                          size="25px"
                          :text="avatarFromName(suppliers.name).text"
                          :style="avatarFromName(suppliers.name).style">
                </b-avatar>
                <b class="ml-2">{{suppliers.name}}</b>
                <b-badge variant="danger" class="ml-2" v-if="suppliers.id && !suppliers.active">Inactivo</b-badge>
                <b-button variant="link" class="list-view-icon-btn ml-auto" v-b-tooltip.hover title="Editar proveedor" aria-label="Editar proveedor" @click="edit()">
                  <AppIcon name="edit" />
                </b-button>
                <b-button variant="link" class="list-view-icon-btn ml-1" v-b-tooltip.hover title="Ocultar información" aria-label="Ocultar información" @click="infoPanelOpen = false">
                  <AppIcon name="chevron_left" />
                </b-button>
              </b-col>
            </b-row>

            <b-row>
              <b-col>

                <div class="ml-5 mt-2">
                  <div v-if="!suppliers.email">
                    <AppIcon name="mail" /> &nbsp;&nbsp;
                    <b-badge variant="warning" class="badget-custom">No tiene un email asociado</b-badge>
                  </div>
                  <div v-else>
                    <AppIcon name="mail" /> &nbsp;&nbsp;
                    <b-link :href="'mailto:' + suppliers.email">
                      {{ suppliers.email }}
                    </b-link>
                  </div>
                </div>

                <div class="ml-5" v-if="suppliers.phone">
                  <AppIcon name="call" /> &nbsp;&nbsp;
                  <b-link :href="'tel:' + suppliers.phone">
                    {{ suppliers.phone }}
                  </b-link>
                </div>

                <div class="ml-5 mt-1">
                  <AppIcon name="truck" /> &nbsp;&nbsp;
                  <b-badge variant="dark" v-if="suppliers.shipping">Transportista</b-badge>
                  <b-badge variant="secondary" v-else>No es transportista</b-badge>
                </div>

              </b-col>
            </b-row>

            <div class="app-modal-detail-list view-supplier-info-blocks" v-if="hasValue(suppliers.observations)">
              <div class="app-modal-detail-list__row">
                <span class="app-modal-detail-list__label"><AppIcon name="chat-square-text" class="mr-1" />Observaciones</span>
                <span class="app-modal-detail-list__value">{{ suppliers.observations }}</span>
              </div>
            </div>
          </b-card>
        </b-col>

        <div v-else
             class="entity-info-panel-collapsed"
             role="button"
             tabindex="0"
             @click="infoPanelOpen = true"
             @keyup.enter="infoPanelOpen = true"
             v-b-tooltip.hover.right
             title="Mostrar información del proveedor">
          <AppIcon name="chevron_right" />
          <span>Proveedor</span>
        </div>

        <b-col :lg="infoPanelOpen ? 8 : null">
          <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark"
                  v-if="showTab">
            <b-tab v-if="this.configTabs.fiscal.show" :active="tabs.fiscal" @click="setActiveTab('fiscal')">
                <template #title><AppIcon name="description" class="mr-1" /> Datos Fiscales</template>
                <tab-fiscal v-if="isSuppliersSales" :suppliers="suppliers" :suppliersID="suppliersID"></tab-fiscal>
            </b-tab>

            <b-tab v-if="this.configTabs.currentAccount.show" :active="tabs.currentAccount" @click="setActiveTab('currentAccount')">
              <template #title><AppIcon name="money" class="mr-1" /> Cuenta Corriente</template>
              <tab-currentAccount :suppliers="suppliers" :suppliersID="suppliersID"></tab-currentAccount>
            </b-tab>

            <b-tab v-if="this.configTabs.accountingAccount.show" :active="tabs.accountingAccount" @click="setActiveTab('accountingAccount')">
              <template #title><AppIcon name="calculator" class="mr-1" /> Cuenta Contable</template>
              <tab-accountingAccount :suppliers="suppliers" :suppliersID="suppliersID"></tab-accountingAccount>
            </b-tab>

            <b-tab v-if="this.configTabs.tasks.show" :active="tabs.tasks" @click="setActiveTab('tasks')" lazy>
              <template #title><AppIcon name="tasks" class="mr-1" /> Tareas</template>
              <RelatedTasksTab relation-type="supplier" :relation-id="suppliersID" />
            </b-tab>

            <b-tab :active="tabs.notes" @click="setActiveTab('notes')" lazy>
              <template #title><AppIcon name="sticky_note_2" class="mr-1" /> Notas</template>
              <RichEditorImages v-model="suppliers.notes" label="Notas importantes" :with-gallery="false" :disabled="!notesEditing" />
              <div class="text-right mt-3">
                <b-button v-if="!notesEditing" variant="outline-secondary" size="sm" @click="notesEditing = true">
                  <AppIcon name="edit" class="mr-1" />Editar notas
                </b-button>
                <b-button v-else variant="dark" size="sm" :disabled="notesSaving" @click="saveNotes(suppliers.notes)">
                  <b-spinner v-if="notesSaving" small class="mr-1" />
                  <AppIcon v-else name="save" class="mr-1" />Guardar notas
                </b-button>
              </div>
            </b-tab>

          </b-tabs>
          <EmptyState v-else
                      icon="people"
                      title="No se encontró información de módulos relacionados" />
        </b-col>
      </b-row>

      <b-card class="mt-2" body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" />
            Volver
          </b-button>
        </div>
      </b-card>

      <b-modal v-model="modal.form.active" :key="modal.form._id" :id="modal.form._id">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>
        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
          <b-tab>
            <template #title><AppIcon name="person" class="mr-1" /> General</template>
            <b-row>
              <b-col md="5">
                <b-form-group label="Logo">
                  <Imagen :images="crud.form.image" @load-image="crud.form.image = $event" typeImage="Logo"/>
                </b-form-group>
              </b-col>
              <b-col md="7">
                <b-row>
                  <b-col md="12">
                    <b-form-checkbox v-model="crud.form.active" switch size="sm" class="mt-4 pull-right">Activo</b-form-checkbox>
                  </b-col>
                  <b-col md="12">
                    <b-form-group label="Código">
                      <b-form-input type="text" size="sm" v-model="crud.form.code" required placeholder="Ingresar un código"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group label="Nombre">
                      <b-form-input type="text" size="sm" v-model="crud.form.name" required placeholder="Ingresar un nombre"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="12">
                <b-form-group label="Email">
                  <b-form-input type="text" size="sm" v-model="crud.form.email" required placeholder="Ingresar un email"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Teléfono" description="Ej: 5493416908870 (13 dígitos)">
                  <b-form-input type="text" size="sm" v-model="crud.form.phone" required placeholder="Ingresar un teléfono"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab>
            <template #title><AppIcon name="chat-square-text" class="mr-1" /> Observaciones</template>
            <b-row>
              <b-col md="12">
                <b-form-checkbox v-model="crud.form.shipping" switch size="sm" class="mb-3 pull-left">¿Es Transportista?</b-form-checkbox>
              </b-col>
              <b-col md="12">
                <b-form-group label="Observaciones">
                  <app-textarea v-model="crud.form.observations" placeholder="Ingresar una observación..." rows="3" size="sm"></app-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Theme from '@/config/theme'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import Storage from '@/handler/storageLocal'
  import TabFiscal from './tabs/fiscal'
  import TabAccountingAccount from './tabs/accountingAccount'
  import TabCurrentAccount from './tabs/currentAccount'
  import {EventBus} from '@/handler/event-bus'
  import Funciones from '@/handler/funciones'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  import Imagen from '@/components/inc/image/image'
  import RichEditorImages from '@/components/inc/editor/RichEditorImages'
  import RelatedTasksTab from '@/components/modules/users/tasks/components/RelatedTasksTab'

  export default {
    components: {
      Widget,
      TabFiscal,
      TabAccountingAccount,
      TabCurrentAccount,
      TabHeaderActions,
      Imagen,
      RichEditorImages,
      RelatedTasksTab,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PROVEEDORES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'view',
          elements: {}
        },
        configTabs: {
          fiscal: {
            show: false,
          },
          accountingAccount: {
            show: false,
          },
          currentAccount: {
            show: false,
          },
          tasks: { show: false },
        },
        configWidget: {
          module_id: Modules.PROVEEDORES,
          profile_id: Profiles.PERSONAL,
          elements: {}
        },
        primaryColor: '',
        infoPanelOpen: true,
        notesSaving: false,
        notesEditing: false,
        suppliersID: 0,
        suppliers: {},
        modulesActive: [],
        crud: {
          form: {
            id: 0,
            name: '',
            phone: '',
            email: '',
            image: [],
            code: '',
            active: true,
            shipping: false,
            observations: '',
          }
        },
        modal: {
          form: {
            active: false,
            title: '',
            _id: '',
          }
        },
        tabs: {
          notes: false,
          fiscal: true,
          accountingAccount: false,
          currentAccount: false,
          tasks: false,
        }
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.suppliersID = this.$route.params.suppliersID
      this.modulesActive = Session.getSession().auth.user.permissions.modules

      this.setup()
      this.load()
      this.configAccess()

      this.restoreStatusTabsStorage()
      if (this.$route.query.tab == 'tasks' && this.configTabs.tasks.show) this.setActiveTab('tasks')
    },
    activated() {
      if (this.$route.query.tab == 'tasks' && this.configTabs.tasks.show) this.setActiveTab('tasks')
    },
    computed: {
      showTab () {
        var status = true
        if(this.configTabs.fiscal.show ||           
           this.configTabs.currentAccount.show ||
           this.configTabs.accountingAccount.show) {
          status = true
        }
        return status
      },    
      isSuppliersSales() {  
        if(this.suppliers.data_fiscal) {
          return true
        } else {
          if(this.suppliers.data_fiscal==undefined) {
            return true
          } else {
            return false
          }
        }
      },
    },
    methods: {
      avatarFromName(name) {
        return Funciones.avatarFromName(name)
      },
      hasValue(value) {
        return !!value && value !== 'null'
      },
      saveNotes(notes) {
        this.notesSaving = true
        serviceAPI.guardarNotas(this.suppliersID, notes)
          .then(response => {
            this.suppliers.notes = response.data.notes
            this.notesEditing = false
            this.$awn.success('Notas guardadas con éxito')
          })
          .catch(error => this.$awn.alert(Error.showError(error)))
          .finally(() => { this.notesSaving = false })
      },
      setMetaTitle(title) {
        EventBus.$emit('Update:TabTitle', 'Proveedor: ' + title)        
      },      
      load() {
        let loader = this.$loading.show();
        var result = serviceAPI.mostrar(this.suppliersID)

        result.then((response) => {
          var data = response.data
          this.suppliers = data   
          this.notesEditing = false

          this.setMetaTitle(this.suppliers.name)

          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },            
      setup () {
        if(Session.getSession().settings) {
          this.primaryColor = Theme.PRIMARY_COLOR

          this.createCSS()
        }
      },
      edit() {
        this.crud.form.id = this.suppliers.id
        this.crud.form.name = this.suppliers.name
        this.crud.form.phone = (this.suppliers.phone!=null) ? this.suppliers.phone : ''
        this.crud.form.email = (this.suppliers.email!=null) ? this.suppliers.email : ''
        this.crud.form.code = (this.suppliers.code!=null) ? this.suppliers.code : ''
        this.crud.form.active = this.suppliers.active
        this.crud.form.shipping = this.suppliers.shipping
        this.crud.form.observations = this.hasValue(this.suppliers.observations) ? this.suppliers.observations : ''

        if(this.suppliers.image && this.suppliers.image.length>0) {
          this.crud.form.image = [{ path: this.suppliers.image }]
        } else {
          this.crud.form.image = []
        }

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Proveedor --> (" + this.crud.form.id + ")" + this.crud.form.name
        this.modal.form.active = true
      },
      save() {
        if(this.crud.form.email) {
          var expreg = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:[.][a-zA-Z0-9-]+)*$")
          if (!expreg.test(this.crud.form.email)) {
            this.$awn.alert("El email no posee un formato válido")
            return false
          }
        }
        if(this.crud.form.phone) {
          if(!Funciones.validarTelefonoWhatsapp(this.crud.form.phone)) {
            this.$awn.alert("El nro de télefono no posee un formato válido para Whatsapp")
            return false
          }
        }

        let loader = this.$loading.show();
        var image = new FormData();
        this.crud.form.image.forEach((value, key) => {
          image.append(key, value.path);
        })

        var result = serviceAPI.editar(JSON.stringify(this.crud.form), image);
        result.then(() => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      },

      configAccess() {        
        this.modulesActive.forEach(element => {
          if(element.id == Modules.COMPRAS) {
            this.configTabs.fiscal.show = true
            this.configTabs.currentAccount.show = true
          } 

          if(element.id == Modules.CONTABILIDAD) {
            this.configTabs.accountingAccount.show = true
          } 

          if(element.id == Modules.TAREAS) {
            this.configTabs.tasks.show = true
          }
        })
      },

      //TABS
      disableAllTabs() {
        this.tabs.notes = false
        this.tabs.fiscal = false
        this.tabs.accountingAccount = false
        this.tabs.currentAccount = false
        this.tabs.tasks = false
      },
      setActiveTab(value) {
        this.disableAllTabs()

        switch (value) {
          case 'notes':
            this.tabs.notes = true
            break;
          case 'tasks':
            this.tabs.tasks = true
            break;
          case 'fiscal':
            this.tabs.fiscal = true
            break;

          case 'accountingAccount':
            this.tabs.accountingAccount = true
            break;

          case 'currentAccount':
            this.tabs.currentAccount = true
            break;        

          default:
            this.tabs.fiscal = true
            break;
        }

        this.saveStatusTabsStorage()
      },

      // FILTROS SAVE
      saveStatusTabsStorage() {
        Storage.setValue('tabs_view_supplier', JSON.stringify(this.tabs))
      },
      restoreStatusTabsStorage() {
        if(Storage.getValue('tabs_view_supplier')) {
          this.tabs = JSON.parse(Storage.getValue('tabs_view_supplier'))
        }         
      },
    }

  }
</script>
<style scoped>
  .view-supplier-info-blocks {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid var(--app-color-border);
  }
  .view-supplier-info-blocks .app-modal-detail-list__value {
    white-space: pre-line;
    word-break: break-word;
  }
  .entity-info-panel-collapsed {
    display: flex;
    flex: 0 0 34px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 260px;
    margin-left: 15px;
    border: 1px solid var(--app-color-border);
    border-radius: 4px;
    background: var(--app-color-surface-subtle);
    color: var(--app-color-primary);
    cursor: pointer;
    writing-mode: vertical-rl;
  }
  @media (max-width: 991.98px) {
    .entity-info-panel-collapsed {
      width: calc(100% - 30px);
      min-height: 34px;
      margin-right: 15px;
      margin-bottom: 10px;
      flex-basis: auto;
      writing-mode: horizontal-tb;
    }
  }
</style>
